/* ═══════════════════════════════════════════════════════════════════════════
   REGISTAR PROPISA I KAZNI — Tacho (usklađeno sa Zakonom).

   Izvor: Zakon o radnom vremenu posade vozila u drumskom prevozu i tahografima
   („Sl. glasnik RS" 96/15, 95/18, 96/25) — tekst: docs/zakon_radno_vreme_posade_96-15_95-18_96-25.txt.
   Kaznene odredbe za pravno lice: čl. 54a (200.000), 55 (120.000), 56 (60.000), 57 (30.000);
   preduzetnik 120/80/40/20 hilj.; odgovorno lice 25/15/10/5 hilj.; vozač čl. 58a/59/60/61 = 50/40/20/10 hilj.
   (Nivo 1 je čl. 54a — čl. 54 je raspon 240–600 hilj. za manipulaciju.)

   Režimi (izbor korisnika, vidi memory/tacho-kazne-decisions):
     AETR — AETR 2010 (= EU 561/2006, domaći čl. 5–8): vožnja, pauze, dnevni i nedeljni odmor.
     RS_M — Propisi R Srbije, međugradski: radno vreme 14h/10h,
            noćna vožnja 3h (interno pravilo — Zakon ga nema), pauze u toku rada, istek kartice, nepoznato.
     RS_G — Propisi R Srbije, gradski i prigradski linijski prevoz (i međumesni do 50 km, ceo u RS):
            čl. 5 st. 4 (8h dnevne vožnje, bez 56h nedeljno), čl. 8 st. 10 (skraćeni nedeljni odmor + dnevni),
            OUT kao u TPS-u (Zakon nema osnov — izbor korisnika), radno vreme i pauze kao međugradski.
   ═══════════════════════════════════════════════════════════════════════════ */

export const MIN = 60 * 1000;
export const H = 60 * MIN;

export const REZIMI = [
    { kljuc: 'AETR', naziv: 'AETR', opis: 'Sporazum AETR (revizija 2010) — vreme upravljanja, pauze i odmori' },
    { kljuc: 'RS_M', naziv: 'R Srbije – međugradski', opis: 'Zakon o radnom vremenu posade vozila: radno vreme, noćni rad, pauze u toku rada' },
    { kljuc: 'RS_G', naziv: 'R Srbije – gradski', opis: 'Gradski i prigradski linijski prevoz (i međumesni do 50 km na teritoriji RS)' },
];
export const nazivRezima = (k) => (REZIMI.find((r) => r.kljuc === k) || {}).naziv || k;

/* Limiti po režimu. `zatvaraPeriod`: odmor kraći od ovoga ne prekida radni period (9h;
   gradski: 7h jer dnevno vreme upravljanja počinje posle neprekidnog odmora od najmanje 7h, čl. 5 st. 5). */
export const LIMITI = {
    AETR: {
        zatvaraPeriod: 9 * H,
        dnevnaVoznja: 9 * H, dnevnaVoznjaProduzena: 10 * H, produzenihNedeljno: 2,
        nedeljnaVoznja: 56 * H, dvonedeljnaVoznja: 90 * H,
        neprekidnaVoznja: 4.5 * H, pauza: 45 * MIN, pauzaPrvi: 15 * MIN, pauzaDrugi: 30 * MIN,
        dnevniOdmor: 11 * H, dnevniOdmorSkraceni: 9 * H, skracenihIzmedjuNedeljnih: 3,
        podeljenPrviDeo: 3 * H, // podeljen dnevni odmor (3h + 9h) = redovan — samo AETR/turistika, gradski ne (odluka vlasnika)
        najduziRadniPeriod: 15 * H,
        nedeljniOdmor: 45 * H, nedeljniOdmorSkraceni: 24 * H, nedeljniNajkasnije: 6 * 24 * H,
    },
    RS_M: {
        zatvaraPeriod: 9 * H,
        radnoVremeMax: 14 * H, radnoVremeNocno: 10 * H, nocnoOdSat: 0, nocnoDoSat: 4,
        kratkaPauza: 15 * MIN, nocnaVoznjaMax: 3 * H, nepoznatoMax: 5 * H, povezanRadMax: 5 * H,
    },
    RS_G: {
        zatvaraPeriod: 7 * H,
        dnevnaVoznja: 8 * H, dvonedeljnaVoznja: 90 * H,
        dnevniOdmor: 11 * H, dnevniOdmorSkraceni: 9 * H, skracenihIzmedjuNedeljnih: 3, najduziRadniPeriod: 15 * H,
        nedeljniOdmorSkraceni: 24 * H, nedeljniNajkasnije: 6 * 24 * H,
        radnoVremeMax: 14 * H, radnoVremeNocno: 10 * H, nocnoOdSat: 0, nocnoDoSat: 4,
        kratkaPauza: 15 * MIN, nepoznatoMax: 5 * H, povezanRadMax: 5 * H, outTolerancija: 15 * MIN,
        kvarVoznja: 4.5 * H, // neprekidna vožnja bez ijednog minuta druge aktivnosti = kvar tahografa (umesto kazne za vožnju)
    },
};

/* ── IZNOSI (fiksni) ──────────────────────────────────────────────────────── */
export const NIVOI = {
    1: { clan: '54a', clanVozac: '58a', pravno: 200000, preduzetnik: 120000, odgovorno: 25000, vozac: 50000 },
    2: { clan: '55', clanVozac: '59', pravno: 120000, preduzetnik: 80000, odgovorno: 15000, vozac: 40000 },
    3: { clan: '56', clanVozac: '60', pravno: 60000, preduzetnik: 40000, odgovorno: 10000, vozac: 20000 },
    4: { clan: '57', clanVozac: '61', pravno: 30000, preduzetnik: 20000, odgovorno: 5000, vozac: 10000 },
};
export const NIVOI_LISTA = [1, 2, 3, 4].map((n) => ({ nivo: n, ...NIVOI[n] }));

/* Prekršaji koji se NE mogu utvrditi iz podataka o aktivnostima — za potpun pregled iznosa. */
export const KAZNE_VAN_OBRACUNA = [
    { opis: 'Manipulacija tahografom (izmena, prikrivanje, brisanje podataka; uređaj za manipulaciju)', osnov: 'čl. 14 st. 5–7; kazna: pravno lice čl. 54 (240.000–600.000), fizičko lice čl. 58 t. 4–6 (80.000–150.000 + 2 kaznena poena)' },
    { opis: 'Upravljanje vozilom sa tuđom karticom vozača', osnov: 'čl. 16 st. 1; fizičko lice čl. 58 t. 7 (80.000–150.000 + 2 kaznena poena)' },
    { opis: 'Nevođenje evidencije o radnom vremenu posade', osnov: 'čl. 4 st. 12; pravno lice čl. 54a t. 1 (200.000)' },
    { opis: 'Nečuvanje evidencije o radnom vremenu dve godine', osnov: 'čl. 4 st. 14; pravno lice čl. 55 t. 8 (120.000)' },
    { opis: 'Nepreuzimanje podataka sa tahografa i kartice u roku — sa gubitkom podataka', osnov: 'čl. 15 st. 5; pravno lice čl. 55 t. 40 (120.000)' },
    { opis: 'Nepreuzimanje podataka sa tahografa i kartice u roku — bez gubitka podataka', osnov: 'čl. 15 st. 5; pravno lice čl. 57 t. 24 (30.000)' },
    { opis: 'Pauza od 5 min na svakom polaznom stajalištu (gradski prevoz) — ne vidi se iz tahografa', osnov: 'čl. 6 st. 4; pravno lice čl. 56 t. 12 (60.000), vozač čl. 59 t. 10 (40.000)' },
];

/* ── STEPENOVANJE (čl. 54a–57, tačke za pravno lice) ─────────────────────────
   Svaka funkcija vraća { nivo, tacka } ili null kad je odstupanje u zakonskoj toleranciji (bez kazne). */

/** Dnevno vreme upravljanja (čl. 5 st. 1 i st. 4): 54a t.3 / 55 t.9 / 56 t.8 / 57 t.5. */
export function stepenDnevnaVoznja(prekoracenje, dozvoljeno, bezOdmora4h30 = true) {
    if (dozvoljeno && prekoracenje >= dozvoljeno * 0.5 && bezOdmora4h30) return { nivo: 1, tacka: '54a t. 3' };
    if (prekoracenje >= 2 * H) return { nivo: 2, tacka: '55 t. 9' };
    if (prekoracenje >= 1 * H) return { nivo: 3, tacka: '56 t. 8' };
    if (prekoracenje > 15 * MIN) return { nivo: 4, tacka: '57 t. 5' };
    return null;
}
/** Nedeljno vreme upravljanja (čl. 5 st. 2): ≥70h 54a t.4; 65–70 55 t.10; 60–65 56 t.9; 56h15–60 57 t.6. */
export function stepenNedeljnaVoznja(ukupno) {
    if (ukupno >= 70 * H) return { nivo: 1, tacka: '54a t. 4' };
    if (ukupno >= 65 * H) return { nivo: 2, tacka: '55 t. 10' };
    if (ukupno >= 60 * H) return { nivo: 3, tacka: '56 t. 9' };
    if (ukupno > 56 * H + 15 * MIN) return { nivo: 4, tacka: '57 t. 6' };
    return null;
}
/** Dvonedeljno (čl. 5 st. 3): ≥112h30 54a t.5; 105– 55 t.11; 100– 56 t.10; 90h15– 57 t.7. */
export function stepenDvonedeljnaVoznja(ukupno) {
    if (ukupno >= 112.5 * H) return { nivo: 1, tacka: '54a t. 5' };
    if (ukupno >= 105 * H) return { nivo: 2, tacka: '55 t. 11' };
    if (ukupno >= 100 * H) return { nivo: 3, tacka: '56 t. 10' };
    if (ukupno > 90 * H + 15 * MIN) return { nivo: 4, tacka: '57 t. 7' };
    return null;
}
/** Period upravljanja bez pauze (čl. 6 st. 1): ≥6h 55 t.12; 5–6h 56 t.11; 4h45–5h 57 t.8. */
export function stepenPeriodUpravljanja(period) {
    if (period >= 6 * H) return { nivo: 2, tacka: '55 t. 12' };
    if (period >= 5 * H) return { nivo: 3, tacka: '56 t. 11' };
    if (period > 4.5 * H + 15 * MIN) return { nivo: 4, tacka: '57 t. 8' };
    return null;
}
/** Dnevni odmor u roku od 24h (čl. 8 st. 2). `dozvoljenSkraceni`: da li je skraćeni (9h) još dozvoljen. */
export function stepenDnevniOdmor(odmorUProzoru, dozvoljenSkraceni) {
    if (dozvoljenSkraceni) {
        if (odmorUProzoru < 7 * H) return { nivo: 2, tacka: '55 t. 18' };
        if (odmorUProzoru < 8 * H) return { nivo: 3, tacka: '56 t. 17' };
        if (9 * H - odmorUProzoru > 15 * MIN) return { nivo: 4, tacka: '57 t. 13' };
        return null;
    }
    if (odmorUProzoru < 8.5 * H) return { nivo: 2, tacka: '55 t. 17' };
    if (odmorUProzoru < 10 * H) return { nivo: 3, tacka: '56 t. 16' };
    if (11 * H - odmorUProzoru > 15 * MIN) return { nivo: 4, tacka: '57 t. 12' };
    return null;
}
/** Kasno započet nedeljni odmor (čl. 8 st. 7): ≥12h 55 t.24; 3–12h 56 t.22; <3h 57 t.18. */
export function stepenKasnoNedeljni(kasnjenje) {
    if (kasnjenje >= 12 * H) return { nivo: 2, tacka: '55 t. 24' };
    if (kasnjenje >= 3 * H) return { nivo: 3, tacka: '56 t. 22' };
    return { nivo: 4, tacka: '57 t. 18' };
}
/** Gradski: skraćeni nedeljni odmor + dnevni odmor (čl. 8 st. 10): manjak >4h 55 t.29; 2–4h 56 t.26; ≤2h 57 t.21. */
export function stepenGradskiNedeljni(manjak) {
    if (manjak > 4 * H) return { nivo: 2, tacka: '55 t. 29' };
    if (manjak > 2 * H) return { nivo: 3, tacka: '56 t. 26' };
    return { nivo: 4, tacka: '57 t. 21' };
}
/** Dnevno radno vreme (čl. 4 st. 2): ≥16h 55 t.2; 15–16 56 t.2; 14–15 57 t.2. */
export function stepenRadnoVreme(ukupno) {
    if (ukupno >= 16 * H) return { nivo: 2, tacka: '55 t. 2' };
    if (ukupno >= 15 * H) return { nivo: 3, tacka: '56 t. 2' };
    return { nivo: 4, tacka: '57 t. 2' };
}
/** Radno vreme uz noćni rad (čl. 4 st. 5): ≥13h 55 t.4; 11–13 56 t.4; 10–11 57 t.4. */
export function stepenNocniRad(ukupno) {
    if (ukupno >= 13 * H) return { nivo: 2, tacka: '55 t. 4' };
    if (ukupno >= 11 * H) return { nivo: 3, tacka: '56 t. 4' };
    return { nivo: 4, tacka: '57 t. 4' };
}
/** Odmor u toku dnevnog rada (čl. 7 st. 2–4) po dužini radnog vremena i iskorišćenoj pauzi. */
export function stepenPauzaURadu(radnoVreme, pauza) {
    const R = [
        { do: 9 * H, potrebno: 30 * MIN, granice: [10 * MIN, 20 * MIN], tacke: ['55 t. 14', '56 t. 13', '57 t. 9'] },
        { do: 12 * H, potrebno: 45 * MIN, granice: [20 * MIN, 30 * MIN], tacke: ['55 t. 15', '56 t. 14', '57 t. 10'] },
        { do: Infinity, potrebno: 60 * MIN, granice: [30 * MIN, 45 * MIN], tacke: ['55 t. 16', '56 t. 15', '57 t. 11'] },
    ];
    if (radnoVreme <= 6 * H) return null;
    const r = R.find((x) => radnoVreme <= x.do);
    if (pauza >= r.potrebno) return null;
    if (pauza <= r.granice[0]) return { nivo: 2, tacka: r.tacke[0], potrebno: r.potrebno };
    if (pauza <= r.granice[1]) return { nivo: 3, tacka: r.tacke[1], potrebno: r.potrebno };
    return { nivo: 4, tacka: r.tacke[2], potrebno: r.potrebno };
}

/* ── KATALOG TIPOVA PREKRŠAJA (za podešavanja prikaza) ───────────────────────
   kljuc je stabilan (čuva se u bazi, dbo.FaultTypeSetting). */
export const TIPOVI = [
    { rezim: 'AETR', kljuc: 'dnevniOdmor', naziv: 'Nedovoljan dnevni odmor / odmor nije u roku od 24h', osnov: 'čl. 8 st. 2 (AETR čl. 8)' },
    { rezim: 'AETR', kljuc: 'skraceniOdmori', naziv: 'Prekoračen broj skraćenih dnevnih odmora', osnov: 'čl. 8 st. 5 (AETR čl. 8)' },
    { rezim: 'AETR', kljuc: 'dnevnaVoznja', naziv: 'Prekoračeno dnevno vreme upravljanja (10h)', osnov: 'čl. 5 st. 1 (AETR čl. 6)' },
    { rezim: 'AETR', kljuc: 'produzeniDani', naziv: 'Prekoračen broj produženih dana upravljanja (9–10h)', osnov: 'čl. 5 st. 1 (AETR čl. 6)' },
    { rezim: 'AETR', kljuc: 'nedeljnaVoznja', naziv: 'Prekoračeno nedeljno vreme upravljanja (56h)', osnov: 'čl. 5 st. 2 (AETR čl. 6)' },
    { rezim: 'AETR', kljuc: 'dvonedeljnaVoznja', naziv: 'Prekoračeno dvonedeljno vreme upravljanja (90h)', osnov: 'čl. 5 st. 3 (AETR čl. 6)' },
    { rezim: 'AETR', kljuc: 'pauza45', naziv: 'Upravljanje duže od 4h30 bez pauze od 45 min', osnov: 'čl. 6 st. 1 (AETR čl. 7)' },
    { rezim: 'AETR', kljuc: 'dvaSkracenaNedeljna', naziv: 'Dva skraćena nedeljna odmora za redom', osnov: 'čl. 8 st. 6 (AETR čl. 8)' },
    { rezim: 'AETR', kljuc: 'nenadoknadjen', naziv: 'Nenadoknađen skraćen nedeljni odmor', osnov: 'čl. 8 st. 9 (AETR čl. 8)' },
    { rezim: 'AETR', kljuc: 'kasnoNedeljni', naziv: 'Kasno započet / nema nedeljnog odmora', osnov: 'čl. 8 st. 7 (AETR čl. 8)' },

    { rezim: 'RS_M', kljuc: 'radnoVreme', naziv: 'Prekoračeno dnevno radno vreme (14h)', osnov: 'čl. 4 st. 2' },
    { rezim: 'RS_M', kljuc: 'nocniRad', naziv: 'Prekoračeno radno vreme uz noćni rad (10h)', osnov: 'čl. 4 st. 5' },
    { rezim: 'RS_M', kljuc: 'nocnaVoznja', naziv: 'Noćna vožnja duža od 3h u periodu 00–04', osnov: 'interno pravilo — Zakon ga ne propisuje' },
    { rezim: 'RS_M', kljuc: 'pauzeURadu', naziv: 'Nedovoljan odmor u toku dnevnog rada (30/45/60 min)', osnov: 'čl. 7 st. 2–4' },
    { rezim: 'RS_M', kljuc: 'istekKartice', naziv: 'Upravljanje sa isteklom karticom vozača', osnov: 'čl. 16 st. 2' },
    { rezim: 'RS_M', kljuc: 'nepoznato', naziv: 'Loše upravljanje tahografom (nepoznata aktivnost / povezan ostali rad > 5h)', osnov: 'interno pravilo (nivo 2)' },

    { rezim: 'RS_G', kljuc: 'g_dnevnaVoznja', naziv: 'Prekoračeno dnevno vreme upravljanja (8h)', osnov: 'čl. 5 st. 4' },
    { rezim: 'RS_G', kljuc: 'g_dvonedeljnaVoznja', naziv: 'Prekoračeno dvonedeljno vreme upravljanja (90h)', osnov: 'čl. 5 st. 3' },
    { rezim: 'RS_G', kljuc: 'g_dnevniOdmor', naziv: 'Nedovoljan dnevni odmor / odmor nije u roku od 24h', osnov: 'čl. 8 st. 2' },
    { rezim: 'RS_G', kljuc: 'g_skraceniOdmori', naziv: 'Prekoračen broj skraćenih dnevnih odmora', osnov: 'čl. 8 st. 5' },
    { rezim: 'RS_G', kljuc: 'g_nedeljniOdmor', naziv: 'Nedeljni odmor kraći od skraćenog nedeljnog + dnevnog', osnov: 'čl. 8 st. 10' },
    { rezim: 'RS_G', kljuc: 'g_kasnoNedeljni', naziv: 'Kasno započet / nema nedeljnog odmora', osnov: 'čl. 8 st. 7' },
    { rezim: 'RS_G', kljuc: 'g_radnoVreme', naziv: 'Prekoračeno dnevno radno vreme (14h)', osnov: 'čl. 4 st. 2' },
    { rezim: 'RS_G', kljuc: 'g_out', naziv: 'Vožnja bez OUT režima', osnov: 'interna provera — Zakon je ne propisuje' },
    { rezim: 'RS_G', kljuc: 'g_istekKartice', naziv: 'Upravljanje sa isteklom karticom vozača', osnov: 'čl. 16 st. 2' },
    { rezim: 'RS_G', kljuc: 'g_kvar', naziv: 'Kvar tahografa (neprekidna vožnja bez druge aktivnosti ili radni dan bez podataka na kartici)', osnov: 'interna provera — bez kazne' },
    { rezim: 'RS_G', kljuc: 'g_nepoznato', naziv: 'Loše upravljanje tahografom (nepoznata aktivnost / povezan ostali rad > 5h)', osnov: 'interno pravilo (nivo 2)' },
];
export const tipZa = (kljuc) => TIPOVI.find((t) => t.kljuc === kljuc) || null;

/** Opis kazne za nivo (tekst za tabelu/izvoz). */
export const fmtRsd = (n) => `${Number(n).toLocaleString('sr-RS')} RSD`;
export function kaznaZa(stepen) {
    if (!stepen) return null;
    const n = NIVOI[stepen.nivo];
    return { ...n, nivo: stepen.nivo, clanTacka: stepen.tacka ? `čl. ${stepen.tacka}` : `čl. ${n.clan}` };
}
